var React = require('react');

function Freezer (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.268 14.836a3.277 3.277 0 0 0-2.266-2.92V3c0-.55-.45-1-1-1s-1 .45-1 1v8.916a3.277 3.277 0 0 0-2.266 2.92h6.532zm1.766-7.084a.932.932 0 0 1 .663-1.137l2.064-.554-1.518-1.491a.943.943 0 0 1 0-1.327.943.943 0 0 1 1.327 0l1.509 1.5.536-2.046a.918.918 0 0 1 1.137-.663c.509.127.8.645.645 1.145l-.527 2.045 2.045-.527a.901.901 0 0 1 1.146.646.918.918 0 0 1-.664 1.136l-2.045.536 1.5 1.509a.946.946 0 0 1 0 1.328.934.934 0 0 1-1.318 0l-1.5-1.518-.555 2.063a.925.925 0 0 1-1.136.664c-.509-.127-.791-.646-.664-1.146l.536-2.036-2.036.536a.929.929 0 0 1-1.145-.663zM8.002 11V3c0-1.66-1.34-3-3-3s-3 1.34-3 3v8a4.997 4.997 0 0 0-1 7 4.997 4.997 0 0 0 7 1 4.997 4.997 0 0 0 1-7 4.74 4.74 0 0 0-1-1z","fill":"currentColor"}));
}

Freezer.defaultProps = {"viewBox":"0 0 19 20"};

module.exports = Freezer;

Freezer.default = Freezer;
